import { associationIdName, fetchGet} from "./common";

export class Newsletter {
    archived!: boolean;
    date!: string;
    id!: number;
    isInformationalBroadcast!: boolean;
    name!: string;

    constructor(data: Newsletter) {
        Object.assign(this, data);
    }

    getDisplayedDate(): string {
        return new Date(this.date).toLocaleDateString(undefined, {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        });
    }
}

export const getNewsletters = async (): Promise<Newsletter[]> => {
    const url = `newsletters?association=${associationIdName}`;
    const response = await fetchGet<Newsletter[]>(url);
    // Only return newsletters that are archived
    return response.filter((data) => data.archived).map((data) => new Newsletter(data));
};

export class NewsletterDetail {
    content!: string;
    date!: string;
    id!: number;
    newsletterName!: string;

    constructor(data: NewsletterDetail) {
        Object.assign(this, data);
    }

    getDisplayedDate(): string {
        return new Date(this.date).toLocaleDateString(undefined, {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        });
    }
}

export const getNewsletter = async (id: number, isInformationalBroadcast: boolean): Promise<NewsletterDetail> => {
    const url = `newsletters/${id}?association=${associationIdName}&isInformationalBroadcast=${isInformationalBroadcast}`;
    const response = await fetchGet<NewsletterDetail>(url);
    return new NewsletterDetail(response);
};
